import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function PelunasanPinjaman() {
  const { id, npp } = useParams();
  const history = useHistory();
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  
  const [dataPinjaman, setDataPinjaman] = useState([]);
  const [empDataPinjaman, setEmpDataPinjam] = useState([]);
  const [listNoPinjam, setListNoPinjam] = useState([]);
  const [noPinjam, setNoPinjam] = useState([]);


  // CONTROLLER

  const fetchDataPinjaman = async (idUser) => {
    setIsLoading(true);
    await baseAPI 
      .get(`/v1/statuspinjaman/${idUser}`, {
         headers: { Authorization: `Bearer ${token}` } 
      })
      .then((res) => {
        const data = res.data.data.belumlunas;

        const listPinjam = [];
        data.forEach(e => {
          listPinjam.push({ label: e.notrxdetailpinjam, value: e.notrxdetailpinjam })
        });

        setListNoPinjam(listPinjam);
        setDataPinjaman(data);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updatePinjaman = async (id, idUser) => {

    Swal.fire({
      title: 'Apakah anda akan mengajukan pelunasan pinjaman ini?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ya',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        baseAPI
          .put(`/v1/ajuanlunastunai/${id}`, null, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Pengajuan pelunasan pinjaman berhasil.",
              showConfirmButton: false,
              timer: 1500
            })
            fetchDataPinjaman(idUser);
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Pengajuan pelunasan pinjaman gagal.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchDataPinjaman(idUser);
          })
      }
    });

  }

  const checkStatusPinjam = (npp, nopinjam) => {

    let data = [];
    dataPinjaman.forEach(e => {
      if(e.notrxdetailpinjam == nopinjam) {
        data.push({
          notrxdetailpinjam: e.notrxdetailpinjam,
          npp_anggota: npp,
          name_anggota: e.name_anggota,
          sisapokok: "Rp." + parseFloat((e.lama - e.cicilan_ke) * e.cpokok).toLocaleString('id-ID'),
          jasabulanRp: "Rp." + parseFloat(e.jasa_bulan).toLocaleString('id-ID'),
          total_lunas: "Rp." + parseFloat(((e.lama - e.cicilan_ke) * e.cpokok) + e.jasa_bulan).toLocaleString('id-ID'),
          status: e.status,
          status_lunas: e.status_lunas,
          plafond: e.plafond,
          lama: e.lama,
          cpokok: e.cpokok,
          jasa_bulan: e.jasa_bulan,
          trxdetailpinjam: e.trxdetailpinjam,
          id_users: e.id_users,
          cicilan_ke: e.lama,
          id: e.id
        })
      }
    });
    setEmpDataPinjam(data[0]);
  }

  useEffect(() => {
    // if (user.role === USP) {
      fetchDataPinjaman(user.id);
    // };
  }, [token]);

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Pinjaman Tunai</Link> /{' '}
              <Link to='/tunai/pelunasanpinjaman' style={{ color: '#333' }}>Pelunasan Pinjaman Tunai</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Pelunasan Pinjaman Tunai Anggota</b></p>
                <p>Silahkan pilih No Pinjaman anda, kemudian cek data pinjaman sebelum mengajukan pelunasan. No Pinjaman yang tersedia adalah pinjaman anda yang telah disetujui dan masih aktif.</p>
              </div>
              {/* No Pinjaman */}
              <div className='col-md-12 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Pengajuan
                </label>
                <Select
                  options={listNoPinjam}
                  defaultValue={listNoPinjam && noPinjam}
                  placeholder="Pilih No Pinjaman"
                  onChange={e => {
                    setNoPinjam(e);
                    checkStatusPinjam(user.npp, e.value);
                  }}
                />
              </div>

              {/* Tanggal Pelunasan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pelunasan
                </label>
                <input
                  defaultValue={moment().format("DD/MM/yyyy")}
                  placeholder='Tanggal pelunasan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* NPP */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  NPP Anggota
                </label>
                <input
                  defaultValue={empDataPinjaman.npp_anggota}
                  placeholder='Employee npp'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Name */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama Anggota
                </label>
                <input
                  defaultValue={empDataPinjaman.name_anggota}
                  placeholder='Employee name'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Sisa pokok pinjaman fix */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Sisa Pokok
                </label>
                <input
                  defaultValue={empDataPinjaman.sisapokok}
                  placeholder='Sisa pokok'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Jasa */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Jasa per Bulan
                </label>
                <input
                  defaultValue={empDataPinjaman.jasabulanRp}
                  placeholder='Jasa per bulan'
                  className="form-control"
                  readOnly
                />
              </div>

              {/* Total Pelunasan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Total Pelunasan
                </label>
                <input
                  defaultValue={empDataPinjaman.total_lunas}
                  placeholder='Total pelunasan'
                  className="form-control"
                  readOnly
                />
              </div>

              <div className='col-md-3'>
                <label className='form-label'>
                  Status:
                </label>
                <span className='badge' style={{backgroundColor: '#333'}}>{empDataPinjaman.status}</span>
              </div>

              {empDataPinjaman.status_lunas != null
              ?
                <div className='col-md-3'>
                  <label className='form-label'>
                    Status Lunas:
                  </label>
                  <span className='badge bg-success'>{empDataPinjaman.status_lunas}</span>
                </div>
              : <></>}

              <div className='col-md-12 mt-2'>
                <button
                  type="button"
                  disabled={empDataPinjaman.status_lunas == null ? false : true}
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => updatePinjaman(empDataPinjaman.id, empDataPinjaman.id_users)}
                >
                  Ajukan Pelunasan
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default PelunasanPinjaman;